export default function ThibodauxAcceptanceFacilitiesSection() {
  const facilities = [
    {
      name: "Thibodaux Post Office",
      address: "307 W 5th St, Thibodaux, LA 70301",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(985) 447-5428",
      notes: "Primary acceptance facility for Thibodaux and northern Lafourche Parish residents. Passport acceptance by appointment. Photo services available nearby. Call ahead to confirm current appointment availability.",
    },
    {
      name: "Lafourche Parish Clerk of Court",
      address: "309 W 3rd St, Thibodaux, LA 70301",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      phone: "(985) 447-4841",
      notes: "Serves all of Lafourche Parish. Full passport acceptance services. Appointment recommended. Convenient for residents throughout the parish from Thibodaux down to Lockport and Cut Off.",
    },
    {
      name: "Raceland Post Office",
      address: "226 Recreation Dr, Raceland, LA 70394",
      hours: "Mon–Fri 9:00 AM – 3:30 PM",
      phone: "(985) 537-5218",
      notes: "Serves Raceland, Mathews, and southern Lafourche Parish communities. Smaller facility — appointment availability fills quickly during peak spring and summer months.",
    },
    {
      name: "Houma Post Office — Main Branch",
      address: "601 Verret St, Houma, LA 70360",
      hours: "Mon–Fri 9:00 AM – 4:00 PM, Sat 9:00 AM – 12:00 PM",
      phone: "(985) 868-5611",
      notes: "Serves Terrebonne Parish and southern Lafourche Parish. Larger facility with more appointment capacity. About 15 miles from Thibodaux. Saturday morning availability — call ahead.",
    },
  ];

  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Passport Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where to Submit a New Passport in Thibodaux
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            First-time applicants and minors must visit an acceptance clerk in person. Thibodaux and Lafourche Parish residents can use these local facilities — and after your clerk visit, ship your documents overnight to Fast Passport Center. No 60-mile drive to New Orleans required.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {facilities.map((f, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
                  <i className="ri-map-pin-2-line text-[#1A365D] text-base"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{f.name}</h3>
                  <p className="text-gray-500 text-xs mt-0.5">{f.address}</p>
                </div>
              </div>
              <div className="space-y-1.5 text-xs text-gray-500 ml-12">
                <p><i className="ri-time-line text-[#F6C344] mr-1"></i>{f.hours}</p>
                <p><i className="ri-phone-line text-[#F6C344] mr-1"></i>{f.phone}</p>
              </div>
              <div className="mt-3 ml-12 bg-white rounded-md p-3 border border-gray-200">
                <p className="text-gray-500 text-xs leading-relaxed">{f.notes}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-[#1A365D] rounded-lg p-6 flex flex-col md:flex-row items-center gap-5 text-center md:text-left">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-lightbulb-line text-[#1A365D] text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-white font-bold text-base mb-1">How This Works With Fast Passport Center</p>
            <p className="text-white/60 text-sm leading-relaxed">
              Visit the Thibodaux or Lafourche Parish clerk with your sealed envelope, ship overnight to Fast Passport Center, and we handle agency submission. No drive to New Orleans. No appointment uncertainty.
            </p>
          </div>
          <a href="https://fastpassportcenter.com/checkout/" className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0">
            Start Now <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}